export const environment = {
  production: true,
  apiUrl: 'https://api.edg-pro.com',
  frontUrl: 'https://edg-pro.com',
  portalUrl: 'https://edg-pro.com',
  domain: 'edg-pro.com',
  tokenName: 'token.edg-pro.com',
  sentry: {
    dsn: 'https://20a531cdd5b543a6ae19bd66d43fa71f@o4504261033000960.ingest.sentry.io/4504261120163840',
    env: 'production',
  },
  binaries: {
    installer: 'https://cdn.edg-pro.com/binaries/Installer.zip',
    moduleBuilder: 'https://cdn.edg-pro.com/binaries/ModuleBuilder.zip',
  },
  contact: 'info@edg-pro.com',
  dataPreview: {
    dataUrl: 'assets/data-preview/18772b00044143c11843468453b59256.data.br',
    frameworkUrl:
      'assets/data-preview/83e0168e173acc34ccf288d977d0673a.framework.js.br',
    codeUrl: 'assets/data-preview/2cb31d5d1a02c0203674e1cc0f143ae7.wasm.br',
  },
  dataPollutionPreview: {
    dataUrl:
      'assets/data-pollution-preview/e3e36ba7562746d89792f299e8c04e18.data.br',
    frameworkUrl:
      'assets/data-pollution-preview/539059769e6fb464ab317af2d6b34294.framework.js.br',
    codeUrl:
      'assets/data-pollution-preview/f8b0a3cee22fc9598f42a0bde5375978.wasm.br',
  },
};
